import { getCookies, checkCookiesList } from 'helpers/utils';

if (document.querySelectorAll('.notifications').length) {
    const notifications = document.querySelectorAll('.notifications');
    const currentNotification = document.querySelectorAll('.notifications')[0];
    const initialMessage = document.getElementsByClassName('initial-message')[0];
    const whiteBackground = document.getElementsByClassName('white-overlay')[0];
    let cookies = [];
    let hideMessage = true;

    window.addEventListener('load', function () {
        getCookies('nc', cookies);
        notifications.forEach((notification) => {
            checkCookiesList(cookies, notification);
            currentNotification.style.transform = `translateY(${
                currentNotification.offsetHeight - initialMessage.offsetHeight
            }px)`;
            setTimeout(function () {
                currentNotification.style.opacity = '1';
                initialMessage.style.transform = 'translateY(0)';
            }, 450);
            notification
                .querySelector('.close-notification span')
                .addEventListener('click', function () {
                    document.cookie = `${this.dataset.cookie}=nc`;
                    whiteBackground.classList.remove('active');
                    currentNotification.style.transform = `translateY(${
                        currentNotification.offsetHeight + initialMessage.offsetHeight
                    }px)`;
                });
        });
    });

    initialMessage.addEventListener('click', function () {
        if (hideMessage) {
            displayMessage();
        } else {
            collapseMessage();
        }
        hideMessage = !hideMessage;
    });

    whiteBackground.addEventListener('click', function () {
        collapseMessage();
        hideMessage = !hideMessage;
    });

    function collapseMessage() {
        initialMessage.querySelector('.message').style.opacity = '1';
        initialMessage.querySelector('.fa-angle-up').style.transform = 'rotate(0)';
        currentNotification.style.transform = `translateY(${
            currentNotification.offsetHeight - initialMessage.offsetHeight
        }px)`;
        whiteBackground.classList.remove('active');
    }

    function displayMessage() {
        initialMessage.querySelector('.message').style.opacity = '.7';
        initialMessage.querySelector('.fa-angle-up').style.transform = 'rotate(180deg)';
        currentNotification.style.transform = `translateY(0%)`;
        whiteBackground.classList.add('active');
    }
}

// if (document.querySelectorAll('.notifications').length) {
//     const notifications = document.querySelectorAll('.notifications')[0];
//     let cookies = [];
//     let activeNotifications = 0;

//     window.addEventListener('load', function () {
//         getCookies('nc');
//         document.querySelectorAll('.notification').forEach(notification => {
//             checkCookiesList(cookies, notification);
//             notification.querySelector('.close-notification .fa-times').addEventListener("click", function () {
//                 const thisNotification = this;
//                 const notificationContent = thisNotification.parentNode.parentNode;
//                 const container = thisNotification.parentNode.parentNode.parentNode;
//                 activeNotifications--;
//                 document.cookie = `${this.dataset.cookie}=nc`
//                 notificationContent.classList.add('remove-notification');
//                 container.style.maxHeight = "0px";
//                 container.addEventListener('transitionend', () => {
//                     container.style.display = "none";
//                     if (activeNotifications <= 0) {
//                         notifications.style.background = "rgba(0,0,0,0)";
//                         setTimeout(function () {
//                             notifications.classList.remove('active_notifications')
//                         }, 1000)
//                     }
//                 }, { once: true })
//             });
//         })
//     })

//     function getCookies(cookieName) {
//         let i, x, y, loadedCookies = document.cookie.split(";");
//         for (i = 0; i < loadedCookies.length; i++) {
//             x = loadedCookies[i].substr(0, loadedCookies[i].indexOf("="));
//             y = loadedCookies[i].substr(loadedCookies[i].indexOf("=") + 1);
//             x = x.replace(/^\s+|\s+$/g, "");
//             if (y === cookieName) {
//                 cookies.push(x)
//             }
//         }
//     }

//     function checkCookiesList(cookieList, classlist) {
//         for (let i = 0; i < cookieList.length; i++) {
//             if (classlist.classList.contains(cookieList[i])) {
//                 return;
//             }
//         }
//         if (!notifications.classList.contains('active_notifications')) {
//             notifications.classList.add('active_notifications')
//         }
//         classlist.classList.add('no-cookie');
//         activeNotifications++;
//     }
// }



// WEBPACK FOOTER //
// ./app/js/modules/dashboard-notification.js